module.exports = __webpack_public_path__ + "img/cg3.fb896b2c.png";